// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2pEz9","checked":"Checkbox_checked__20bOV"};